const DUPLEXER_EVENTS = {
  TYPING: 'client-typing',
  NEW_POST: 'new-post',
  NEW_COMMENT: 'new-comment',
  UPDATE_POST_COUNTERS: 'update-post-counters',
  UPDATE_CATEGORY_COUNTERS: 'update-category-counters',
};

const DUPLEXER_CHANNELS = {
  FORUM: 'forum',
  CATEGORY: 'category',
  POST: 'post',
};

module.exports = { DUPLEXER_EVENTS, DUPLEXER_CHANNELS };
